/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-06-21 10:35:57.

import { Currency } from "./BookitupDocument";

export interface BlockStyleDto extends KafkaDto {
  profileId: number;
  horizontalAlignment: HorizontalAlignment;
  fontColor: string;
  backgroundColor: string;
  borderColor: string;
  borderRadius: number;
  paddingTop: number;
  paddingBottom: number;
  paddingLeft: number;
  paddingRight: number;
  width: number;
}

export interface ContractDto extends KafkaDto {
  profileId: number;
  contactId: number;
  customerId: number;
  eventId: number;
  draft: boolean;
  subject: string;
  title: string;
  label: string;
  date: Date | null;
  number: string;
  aboveTextBlocks: TextBlockDto[];
  belowTextBlocks: TextBlockDto[];
  documentId: number | null;
  positions: PositionDto[];
  sum: number;
  subtotal: number;
  taxType: TaxType;
  summable: boolean;
  contractHead: ContractHead;
  contractFooter: ContractFooter;
  contractSign: ContractSign;
  customerSignType: CustomerSignType;
  fileName: string;
  creatable: boolean;
  frontCoverEntityId: string | null;
  frontCoverEntityType: string | null;
  frontCoverFileName: string | null;
  frontCoverPageCount: number;
  backCoverEntityId: string | null;
  backCoverEntityType: string | null;
  backCoverFileName: string | null;
  backCoverPageCount: number;
  digitalSignLink: string;
  discount: DiscountDto;
  taxSummary: TaxSummaryDTO;
  agreements: AgreementDTO[];
}

export interface ContractTemplateDto extends KafkaDto {
  profileId: number;
  name: string;
  standard: boolean;
  subject: string;
  title: string;
  positions: boolean | null;
  aboveTextBlocks: TextBlockDto[];
  belowTextBlocks: TextBlockDto[];
  frontCoverEntityId: string | null;
  frontCoverEntityType: string | null;
  frontCoverFileName: string | null;
  frontCoverPageCount: number;
  backCoverEntityId: string | null;
  backCoverEntityType: string | null;
  backCoverFileName: string | null;
  backCoverPageCount: number;
  contractHead: ContractHead;
  contractFooter: ContractFooter;
  contractSign: ContractSign;
  customerSignType: CustomerSignType;
  lastModified: Date;
  agreements: AgreementDTO[];
  label: string | null;
}

export interface CreateContractTemplateDto {
  name: string;
  subject: string;
  positions: boolean;
  aboveTextBlocks: CreateTextBlockDto[];
  belowTextBlocks: CreateTextBlockDto[];
  contractHead: ContractHead;
  contractFooter: ContractFooter;
  contractSign: ContractSign;
  customerSignType: CustomerSignType;
}

export interface CreateTextBlockDto {
  contentFirstColumn: string;
  headerFirstColumn: string;
  contentSecondColumn: string;
  headerSecondColumn: string;
}

export interface DiscountDto {
  value: number;
  type: DiscountType;
  description: string;
  amount: number;
}

export type Language = 'german' | 'english';

export interface DocumentDto extends KafkaDto {
  originDocumentId: number;
  profileId: number;
  contactId: number;
  customerId: number;
  eventId: number;
  draft: boolean;
  summable: boolean;
  subject: string;
  label: string;
  documentType: DocumentType;
  number: string;
  shippingType: ShippingType;
  shippingDate: Date;
  shippingEndDate: Date;
  date: Date;
  validUntil: Date;
  headRow: string;
  endRow: string;
  positions: PositionDto[];
  partialInvoices: PartialInvoiceDto[];
  fileName: string;
  sum: number;
  subtotal: number;
  digitalSignLink: string;
  taxType: TaxType;
  dueDate: Date;
  taxSummary: TaxSummaryDTO;
  discount: DiscountDto;
  locked: boolean;
  hasPayments: boolean;
  finalTaxSummary: TaxSummaryDTO;
  finalSum: number;
  finalInvoiceCreatable: boolean;
  finalNet: number;
  acceptedAt: Date;
  paid: boolean;
  daysTilExpire: number;
  language?: Language | null;
}

export interface DocumentTemplateDto {
  id: number;
  name: string;
  standard: boolean;
  profileId: number;
  summable: boolean;
  subject: string;
  label: string;
  documentType: DocumentType;
  headRow: string;
  endRow: string;
  positions: PositionDto[];
  sum: number;
  subtotal: number;
  taxType: TaxType;
  taxSummary: TaxSummaryDTO;
  discount: DiscountDto;
  finalNet: number;
  currencySymbol: string;
  currency: Currency;
  language?: Language | null;
}

export interface DocumentIdListDto {
  documentIds: number[];
}

export interface DocumentTemplateDTO {
  templateName: string;
  documentNumber: string;
  documentType: DocumentType;
  documentId: number;
}

export interface DocumentTemplateKafkaDto extends KafkaDto {
  profileId: number;
  documentType: DocumentType;
  name: string;
  standard: boolean;
  subject: string;
  headRow: string;
  endRow: string;
  positions: PositionDto[];
  summable: boolean;
}

export interface DocumentTemplateSetDTO {
  eventId: number;
  customerContactId: number;
  documentTemplates: DocumentTemplateDTO[];
}

export interface EventIdListDto {
  eventIds: number[];
}

export interface EventListDto {
  events: EventDto[];
}

export interface ExistingDto {
  entityId: number;
  entityType: string;
  fileName: string;
}

export interface IdListDto {
  ids: number[];
}

export interface PartialInvoiceDto extends KafkaDto {
  date: Date;
  documentNumber: string;
  label: string;
  gross: number;
  vat: number;
  net: number;
  taxRate: number;
}

export interface PositionDto extends KafkaDto {
  label: string;
  subtext: string;
  price: number;
  netPrice: number;
  priceUnit: number;
  netPriceUnit: number;
  tax: number;
  amount: string;
  unit: string;
  priceSubtext: string;
  optional: boolean;
  profileId: number;
  discount: DiscountDto;
}

export interface TaxEntryDTO {
  amount: number;
  taxRatePercent: number;
  taxAmount: number;
}

export interface TaxSummaryDTO {
  taxEntries: TaxEntryDTO[];
}

export interface TextBlockDto extends KafkaDto {
  profileId: number;
  isAbove: boolean;
  contentFirstColumn: string | null;
  headerFirstColumn: string;
  imageEntityTypeFirstColumn: string | null;
  imageEntityIdFirstColumn: string | null;
  imageFileNameFirstColumn: string | null;
  styleFirstColumn: BlockStyleDto;
  styleSecondColumn: BlockStyleDto;
  contentSecondColumn: string | null;
  headerSecondColumn: string;
  imageEntityTypeSecondColumn: string | null;
  imageEntityIdSecondColumn: string | null;
  imageFileNameSecondColumn: string | null;
}

export interface KafkaDto extends Serializable {
  id: number;
  lastModified: Date;
}

export interface EventDto {
  id: number;
  sumOpen: number;
  sumConfirmed: number;
}

export interface Serializable {}

export type HorizontalAlignment = 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';

export const horizontalAlignmentToCssProp = (horizontalAlignment?: HorizontalAlignment) => {
  if (!horizontalAlignment) {
    return 'left';
  }
  if (horizontalAlignment === 'JUSTIFIED') {
    return 'justify';
  }
  return horizontalAlignment.toLocaleLowerCase();
};

export type TaxType =
  | 'net'
  | 'gross'
  | 'vatfree'
  | 'intraCommunitySupply'
  | 'constructionService13b'
  | 'externalService13b'
  | 'thirdPartyCountryService'
  | 'thirdPartyCountryDelivery';

export type ContractHead = 'NONE' | 'LETTERHEAD' | 'PARTIES';

export type ContractFooter = 'NONE' | 'CENTERED' | 'BLOCKS';

export type ContractSign = 'NONE' | 'BOTH' | 'CUSTOMER';

export type CustomerSignType = 'BASE64' | 'TEXT_FIELD' | 'IMAGE_UPLOAD';

export type DiscountType = 'PERCENT' | 'ABSOLUTE';

export type DocumentType =
  | 'OFFER'
  | 'CONFIRMATION'
  | 'CONTRACT'
  | 'DELIVERYNOTE'
  | 'INVOICE'
  | 'PARTIAL_INVOICE'
  | 'CANCEL'
  | 'REMINDER'
  | 'QUESTIONNAIRE';

export type ShippingType = 'service' | 'serviceperiod' | 'delivery' | 'deliveryperiod' | 'none';

export type AgreementDTO = {
  id: string;
  content: string;
  required: boolean;
  entityId: string | null;
  entityType: string | null;
  fileName: string | null;
};

export type CreateContractRequest = {
  customerId: number;
  template?: string;
  templateId?: number;
  eventId?: number;
  documentId: number;
};
